import type { Components, Theme } from "@mui/material";

export const MuiDialog: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        margin: "0rem",
        padding: "0rem",
        fontWeight: theme.typography.h5.fontSize,
      };
    },
    paper: {
      width: "75vw",
      background: "#FFF",
      paddingBottom: "2rem",
      borderRadius: "1.25rem",
      maxWidth: "99vw",
    },
  },
};
